<template>
  <SelectCreateUser v-model="inputedValue" :height="height" :clearable="true" />
</template>

<script>
import SelectCreateUser from './SelectCreateUser'

export default {
  components: {
    SelectCreateUser
  },
  props: {
    value: {
      type: Object,
      require: true,
      default: () => ({})
    },
    height: { default: '32px' }
  },
  data: () => ({
    //
  }),
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
